import React, {Component} from 'react';
import classNames from 'classnames';
// import Swiper from 'react-id-swiper';
import {Animated} from "react-animated-css"; 
// import 'react-id-swiper/src/styles/css/swiper.css';
import 'styles/PortfolioPage.css';
// import TransitionGroup from 'react-transition-group/TransitionGroup';

import PortfolioSlide from 'scripts/components/portfolioSlide';

import Preload from 'react-preload'

// 140 - CMS sites
// 141 - pixel perfect
// 142 - 
// 143 - 

var ga = window.ga;
var TimelineMax = window.TimelineMax

const customEase = window.CustomEase.create("custom", "M0,0 C0.08,0.034 0.2,0.12 0.2,0.12 0.2,0.12 0.392,0.246 0.484,0.486 0.516,0.57 0.552,0.732 0.615,0.826 0.69,0.937 0.704,1 1,1")

class PortfolioPage extends Component {
  constructor(props) {
    super(props);

    const hover = [];
    this.props.portfolio.forEach(() => {
      hover.push(false);
    });

    this.state = {
      currentSlide: 0,
      direction: 1,
      disabled: false,
      show: false,
      filter: 0,
      hover: [...hover],
      swiper1: null,
      swiper2: null,
      swiper3: null,
      swiper4: null,
      swiper5: null,
      activeSlideIndex1: 0,
      activeSlideIndex2: 0,
      activeSlideIndex3: 0,
      activeSlideIndex4: 0,
      activeSlideIndex5: 0,
      activeNextSlide: false,
      activePrevSlide: false,
    }
  }

  componentDidMount() {
    ga('send', 'event', 'Portfolio: ' + this.props.title, 'Page View');
    this.sizeSlider()
    window.addEventListener('resize', this.sizeSlider);
    document.querySelector('html').classList.add('portfolio')
  }

  _handleImageLoadSuccess = () => {
    setTimeout(() => {
      this.setState({
        show: true
      }, this.animationPortfolioIn)
    }, 2200);
  }

  sizeSlider = () => {
    // let el = this.el;
    // let container = el.querySelector('')
  }

  animationPortfolioIn = () => {
    let tl = new TimelineMax()
    let el = this.el
    let slides = [
      el.querySelectorAll('.Portfolio__Item')[0],
      el.querySelectorAll('.Portfolio__Item')[1],
      el.querySelectorAll('.Portfolio__Item')[2]
    ]


    setTimeout(function(){
      for(var i = 0; i < slides.length; i++){
          tl.to(slides[i], 0.6, {opacity: 1, ease:window.Sine.easeIn}, 0.64+(i*0.12))
          .from(slides[i], (1.2*((slides.length - i)/1.6)), {x: 240, ease:window.Power4.easeOut}, 0.64+(i*0.12))
      }
    }, 800)
  }


  playVideo = (e) => {
    let vid = e.currentTarget.querySelector('video')
    vid.currentTime = 0;
    vid.play();
  }

  pauseVideo = (e) => {
    let vid = e.currentTarget.querySelector('video')
    vid.pause();
  }

  generatePorfolioItem = (item) => {
    // console.log(item.projectClip[0])
    let video = item.projectClip[0] ? item.projectClip[0].filename : null

    return (
      <div className="Portfolio__Item">
        {item.projecturl ?
            <a href={item.projecturl} target="_blank">
              <div className="Portfolio__Item-img"  style={{ backgroundImage: `url('${item.projectImage}')` }}  onMouseEnter={this.playVideo} onMouseLeave={this.pauseVideo}>
                <div className="Portfolio__item--gradient" />
                <div className="hover-video">
                  <video src={'https://savage.devlink.online/images/' + video} loop muted playsInline/>
                </div>
              </div>
            </a>
          : 
            <div className="Portfolio__Item-img"  style={{ backgroundImage: `url('${item.projectImage}')` }} onMouseEnter={this.playVideo} onMouseLeave={this.pauseVideo}>
              <div className="Portfolio__item--gradient" />
              <div className="hover-video">
                <video src={'https://savage.devlink.online/images/' + video} loop muted playsInline/>
              </div>
            </div>
        }
        <div className="Portfolio__item-text">
          <div className="Portfolio__item-title">
            { item.title }
          </div>
          <div className="Portfolio__item-subtitle">
            <span>Role:</span>&nbsp;{ item.projectRole }
          </div>
        </div>
      </div>
    );
  }

  generatePorfolioMobileItem = (item) => {
    return (
      <div className="Portfolio__Item">
        <a
          href={item.projecturl}
          target="_blank"
        >
          <div className="Portfolio__Item-img"  style={{ backgroundImage: `url('${item.projectImage}')` }}>
            <div className="Portfolio__item--gradient" />
          </div>
        </a>
        <div className="Portfolio__item-text">
          <div className="Portfolio__item-title">
            { item.title }
          </div>
          <div className="Portfolio__item-subtitle">
            <span>Role:</span>&nbsp;{ item.projectRole }
          </div>
        </div>
      </div>
    );
  }

  changeFilter = (val) => {
    this.changeSlide(0)
    this.setState({
      filter: val,
      // currentSlide: 0
    });
  }

  goNext() {
    let { filter, currentSlide } = this.state
    let { portfolio } = this.props
    let array = filter  === 0 ? portfolio : this.getFilteredItems(filter)
    let val = currentSlide >= array.length - 1 ? 0 : currentSlide + 1
    this.changeSlide(val);
  }

  goPrev() {
    if(this.state.currentSlide <= 0){
      return;
    }
    let val = this.state.currentSlide - 1;
    this.changeSlide(val);
  }

  changeSlide = (index) => {
    this.setState({
      currentSlide: index
    }, this.moveSlider)
  }

  moveSlider = () => {
    let el = this.el;
    let currSlide = this.state.currentSlide
    let cont = el.querySelector('.PortfolioPage__animation.active');
    let slider = cont.querySelector('.PortfolioPage__slider')
    let sliderWrap = slider.querySelector('.PortfolioPage__Swiper')
    let width = sliderWrap.offsetWidth
    let tl = new TimelineMax()

    let durOffset = Math.abs(slider.getAttribute('data-offset') - currSlide)
    let dur = 1 + (Math.log(durOffset))/1.6

    tl.to(slider, dur, {x: -1*width*currSlide, ease: window.Power4.easeOut})

    slider.setAttribute("data-offset", currSlide); 
  }


  getFilteredItems = (id) => {
      id = id.toString()
      const { portfolio } = this.props;
      return portfolio.filter((item) => {
        let filter = item.filter;
        for (var key in filter) {
            if(filter[key].id === id){
              return item;
            }
        }
      })
  }


  render() {
    const { portfolio, filters } = this.props;
    const { filter, currentSlide } = this.state;
    const generalParams = {
      spaceBetween: 0,
      slidesPerView: 'auto',
      centeredSlides: true,
      speed: 640,
      loop: true,
      direction: 'horizontal',
      scrollBar: false,
      containerClass: 'PortfolioPage__Swiper',
      /* autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      }, */
      mousewheel: {
        invert: false,
      },
    };
    const arrowSwiperStateParams = {
      slideNextTransitionStart:
        () => {
          this.setState({ activeNextSlide: true });
        },
      slideNextTransitionEnd:
        () => {
          this.setState({ activeNextSlide: false });
        },
      slidePrevTransitionStart:
        () => {
          this.setState({ activePrevSlide: true });
        },
      slidePrevTransitionEnd:
        () => {
          this.setState({ activePrevSlide: false });
        },
    };
    

    let loadingIndicator = (<div id='_preload_div_'> <img src="_anim/images/_preloader.gif"/> </div>)

    let portfolioItems = [];
    if (Array.isArray(portfolio)) {
      portfolioItems = [...portfolio];
    }

    let activeSlideIndex = 0;
    let totalItems = portfolioItems.length;

    const allItems = portfolioItems;

    const ppdItems = this.getFilteredItems('141');
    const cmsItems = this.getFilteredItems('140');
    const appsGamesItems = this.getFilteredItems('142');
    const bannersItems = this.getFilteredItems('143');

    if (filter === 0) {
      activeSlideIndex = this.state.activeSlideIndex1;
      totalItems = allItems.length;
    } else if (filter === 141) {
      activeSlideIndex = this.state.activeSlideIndex2;
      totalItems = ppdItems.length;
    } else if (filter === 140) {
      activeSlideIndex = this.state.activeSlideIndex3;
      totalItems = cmsItems.length;
    } else if (filter === 142) {
      activeSlideIndex = this.state.activeSlideIndex4;
      totalItems = appsGamesItems.length;
    } else if (filter === 153) {
      activeSlideIndex = this.state.activeSlideIndex5;
      totalItems = bannersItems.length;
    }

    let filterClasses = classNames({
      'PortfolioPage__filters': true
    })

    return (
      <div
        id="PortfolioPage"
        className={classNames('PortfolioPage', {
            display: this.state.show,
        })} 
        ref={(el) => this.el = el}
      >
        <Preload
          loadingIndicator={loadingIndicator}
          autoResolveDelay={12000}
          // onError={this._handleImageLoadError}
          onSuccess={this._handleImageLoadSuccess}
          resolveOnError={true}
          mountChildren={true}
        >
          <div className="PortfolioPage__display">
            <div className="PortfolioPage__background" />
            <div className="PortfolioPage__content">
              <Animated className={'PortfolioPage__animation ' + (this.state.filter === 0 ? 'active' : '')} animationIn="fadeInDown" animationInDuration={1500}  animationOut="fadeOutDown" animationOutDuration={1000} isVisible={this.state.filter === 0}>
                <div className="PortfolioPage__slider" data-offset="0">
                  <div className="PortfolioPage__Swiper">
                      {
                        allItems.map((item, index) => this.generatePorfolioItem(item, index))
                      }
                  </div>
                </div>
              </Animated>

              <Animated className={'PortfolioPage__animation ' + (this.state.filter === 141 ? 'active' : '')} animationIn="fadeInDown" animationInDuration={1500}  animationOut="fadeOutDown" animationOutDuration={1000} isVisible={this.state.filter === 141}>
                <div className="PortfolioPage__slider" data-offset="0">
                    <div className="PortfolioPage__Swiper">
                      {
                        ppdItems.map((item, index) => this.generatePorfolioItem(item, index))
                      }
                    </div>
                </div>
              </Animated>
              <Animated className={'PortfolioPage__animation ' + (this.state.filter === 140 ? 'active' : '')} animationIn="fadeInDown" animationInDuration={1500}  animationOut="fadeOutDown" animationOutDuration={1000} isVisible={this.state.filter === 140}>
                <div className="PortfolioPage__slider" data-offset="0">
                    <div className="PortfolioPage__Swiper">
                      {
                        cmsItems.map((item, index) => this.generatePorfolioItem(item, index))
                      }
                    </div>
                </div>
              </Animated>
              <Animated className={'PortfolioPage__animation ' + (this.state.filter === 142 ? 'active' : '')} animationIn="fadeInDown" animationInDuration={1500}  animationOut="fadeOutDown" animationOutDuration={1000} isVisible={this.state.filter === 142}>
                <div className="PortfolioPage__slider" data-offset="0">
                    <div className="PortfolioPage__Swiper">
                      {
                        appsGamesItems.map((item, index) => this.generatePorfolioItem(item, index))
                      }
                    </div>
                </div>
              </Animated>
              <Animated className={'PortfolioPage__animation ' + (this.state.filter === 143 ? 'active' : '')} animationIn="fadeInDown" animationInDuration={1500}  animationOut="fadeOutDown" animationOutDuration={1000} isVisible={this.state.filter === 143}>
                <div className="PortfolioPage__slider" data-offset="0">
                    <div className="PortfolioPage__Swiper">
                      {
                        bannersItems.map((item, index) => this.generatePorfolioItem(item, index))
                      }
                    </div>
                </div>
              </Animated>

              <div className="Porfolio__mobile">
                { allItems.map((item, index) => this.generatePorfolioMobileItem(item, index)) }
              </div>
              


              <div className={filterClasses}>
                <div className="PortfolioPage__filter">
                  <span
                    className={classNames({ active: this.state.filter === 0 })}
                    onClick={this.changeFilter.bind(this, 0)}
                  >
                    All
                  </span>
                </div>

                <div className="PortfolioPage__filter">
                  <span
                    className={classNames({ active: this.state.filter === 141 })}
                    onClick={this.changeFilter.bind(this, 141)}
                  >
                    Pixel Perfect Development
                  </span>
                </div>
                <div className="PortfolioPage__filter">
                  <span
                    className={classNames({ active: this.state.filter === 140 })}
                    onClick={this.changeFilter.bind(this, 140)}
                  >
                    CMS Sites
                  </span>
                </div>
                <div className="PortfolioPage__filter">
                  <span
                    className={classNames({ active: this.state.filter === 142 })}
                    onClick={this.changeFilter.bind(this, 142)}
                  >
                    Apps &amp; Games
                  </span>
                </div>
                <div className="PortfolioPage__filter">
                  <span
                    className={classNames({ active: this.state.filter === 143 })}
                  >
                    <a href="https://bannerisland.co" target="_blank">Banners</a>
                  </span>
                </div>
              </div>
              <div className="PortfolioPage__pages">
                <div className="PortfolioPage__page-current">
                  { (currentSlide + 1).toString().length === 1 ? `0${currentSlide + 1}` : (currentSlide + 1) }
                </div>
                <div className="PortfolioPage__page-total">
                  { (totalItems).toString().length === 1 ? `0${totalItems}` : (totalItems) }
                </div>
              </div>
              <div className="PortfolioPage__arrows">
                <div
                  className={classNames('PortfolioPage__arrow PortfolioPage__arrow-left', { active: this.state.activePrevSlide })}
                  onClick={this.goPrev.bind(this)}
                />
                <div
                  className={classNames('PortfolioPage__arrow PortfolioPage__arrow-right', { active: this.state.activeNextSlide })}
                  onClick={this.goNext.bind(this)}
                />
              </div>
            </div>
          </div>
        </Preload>

        <div className="portrait-container">
            <h3>Please view in landscape for best experience.</h3>
        </div>
      </div>
    );
  }
}

export default PortfolioPage;



// WEBPACK FOOTER //
// ./src/scripts/containers/PortfolioPage.js